
import service from '@/service/chat_api'
import r4InvoiceApiList from "../service/basic/r4InvoiceApiList";
const myhost = myhostname

// 获取待开票列表
export function queryUnInvoiceList(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4InvoiceApiList.getUnInvoiceList}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取待开票列表
export function queryInvoiceList(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4InvoiceApiList.getInvoiceList}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取待开票列表
export function queryInvoiceItemList(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4InvoiceApiList.getInvoiceItemList}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取发票图片
export function loadInvoiceImage(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4InvoiceApiList.getInvoiceImage}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取结算单明细
export function querySettleItemList(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4InvoiceApiList.getSettleItemList}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取结算单明细
export function queryInvoiceItemInfo(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4InvoiceApiList.getInvoiceItemInfo}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
// 获取查看快递图片
export function queryDeliveryImage(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4InvoiceApiList.getDeliveryImage}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
// 生成发票
export function queryInvoice(params = {}) {
  return new Promise((resolve, reject) => {
    service.post(`${myhost}${r4InvoiceApiList.getInvoice}`, params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/models/r4InvoiceModel.js